{
  "cancellation": {
    "confirmationTitle": "Abonnement kündigen",
    "confirmationBodyOne": "Bist du sicher, dass du dein Abonnement kündigen möchtest",
    "confirmationBodyTwo": "Nach Ablauf des Abonnements haben Sie keinen Zugriff mehr auf Ihr Konto und Ihre Daten",
    "reasonHeadingOne": "Es tut uns leid, dass du gehst.",
    "reasonHeadingTwo": "Wir würden uns freuen, Ihre Meinung dazu zu erhalten, wie wir Iventis verbessern können.",
    "reasonSubheadingOne": "Was ist der Hauptgrund für die Stornierung?",
    "reasonSubheadingTwo": "Bitte geben Sie zusätzliches Feedback",
    "reasonOne": "Ich kann Iventis nicht vollständig nutzen",
    "reasonTwo": "Ich finde es schwierig, es zu benutzen",
    "reasonThree": "Es hat keine Funktion, nach der ich suche",
    "reasonFour": "Es ist zu teuer",
    "reasonFive": "Ich habe beschlossen, auf ein anderes Produkt umzusteigen",
    "reasonSix": "Anderes",
    "addComment": "Einen Kommentar hinzufügen",
    "cancelSubscription": "Abonnement kündigen",
    "reactivate": "Reaktiviere dein Abonnement",
    "success": "Ihr Abonnement wurde gekündigt und läuft am ab",
    "error": "Bei der Kündigung Ihres Abonnements ist ein Problem aufgetreten. Bitte wenden Sie sich an den Support.",
    "successReactivate": "Ihr Projekt wurde reaktiviert",
    "errorReactivate": "Bei der Reaktivierung Ihres Abonnements ist ein Problem aufgetreten. Bitte wenden Sie sich an den Support.",
    "contactUs": "Kontaktieren Sie den Support",
    "nonAutomatedCancel": "Bitte kontaktieren Sie den Support, um Ihr Abonnement zu kündigen",
    "nonAutomatedReactivate": "Bitte kontaktieren Sie den Support, um Ihr Abonnement zu reaktivieren",
    "cancelsOn": "Storniert am",
    "keepSubscription": "Abonnement behalten"
  },
  "limits": {
    "limitedResource": {
      "IndividualMap": "Pläne",
      "TeamMap": "Pläne",
      "User": "Benutzer"
    },
    "out_of": "{{ current }} von {{ maximum }} aktiven {{ resources }}",
    "users": {
      "limitReached": {
        "title": "Benutzerlimit erreicht",
        "content": "Sie haben die maximale Anzahl von Benutzern für dieses Projekt erreicht. Um weitere Benutzer hinzuzufügen, klicken Sie bitte"
      },
      "limitRemaining": {
        "title": "1 Benutzer verbleibt",
        "content": "Sie sind dabei, die maximale Anzahl von Benutzern für dieses Projekt zu erreichen. Um weitere Benutzer hinzuzufügen"
      }
    },
    "custom_layer": {
      "title": "Führe ein Upgrade durch, um deinen Layer individuell zu gestalten",
      "content": "Hol dir ein Upgrade auf unseren Professional-Tarif für grenzenlose Anpassungen oder kontaktiere uns unter:"
    }
  }
}